@if (rootViewModel) {
  <div class="main-container">
    @for (panel of layoutMetaData.panels; track panel; let i = $index) {
      <nts-expandable
        [panels]="rootViewModel.panels"
        [panelId]="panel.panelId" [isCollapsed]="panel.panelState == panelState.Collapsed"
        [isVisible]="panel.isVisible"
        [disableToggle]="panel.disableToggle ?? false"
        [showHeader]="panel.showHeader ?? true"
        [title]="panel.descriptions.displayName" [showAdditionalFields]="panel.panelState == panelState.Expanded"
        [hideAdditionalFieldsToggle]="panel.additionalFields.length == 0"
        [promotedFields]="getPromotedFields(panel, i)">
        @for (field of getResponsiveFields(panel); track field) {
          @if (field.fieldType === fieldType.Spacer) {
            <nts-spacer-box #expandableChild [isHidden]="!field.isVisible"
              [additionalField]="field.isAdditionalField" [fullColumn]="field.isFullColumn"
              [uniqueId]="field.uniqueId" [spacers]="rootViewModel.spacers">
            </nts-spacer-box>
          }
          @if (field.fieldType === fieldType.Simple) {
            <nts-labelled-text-box #expandableChild
              [isHidden]="!field.isVisible" [additionalField]="field.isAdditionalField"
              [fullColumn]="field.isFullColumn"
              [isDisabled]="field.isDisabled"
              [path]="field.path"
              [name]="field.name"
              [multiline]="getSimpleFieldMetaDataFromFieldMetaData(field).isMultiLine"
              [propertyViewModel]="getPropertyViewModelFromFieldMetaData(field)">
            </nts-labelled-text-box>
          }
          @if (field.fieldType === fieldType.Grid) {
            <nts-grid #expandableChild [isHidden]="!field.isVisible"
              [path]="field.path"
              [name]="field.name"
              [fullColumn]="field.isFullColumn"
              [areAllCommandsDisabled]="getGridMetaDataFromFieldMetaData(field).areAllCommandsDisabled"
              [isDisabled]="getGridMetaDataFromFieldMetaData(field).areAllColumnsDisabled"
              [title]="getGridMetaDataFromFieldMetaData(field).showTitle ? field.description : ''"
              [showToolbar]="getGridMetaDataFromFieldMetaData(field).showToolbar"
              [additionalField]="field.isAdditionalField"
              [minRowNumberHeight]="getGridMetaDataFromFieldMetaData(field).minRowNumberHeight"
              [dynamicHeight]="getGridMetaDataFromFieldMetaData(field).dynamicHeight"
              [collectionViewModel]="getCollectionViewModelFromGridFieldMetaData(getGridMetaDataFromFieldMetaData(field))"
              [columns]="getCollectionViewModelColumnsFromGridFieldMetaData(getGridMetaDataFromFieldMetaData(field))">
            </nts-grid>
          }
          @if (field.fieldType === fieldType.External) {
            <nts-decode-text-box #expandableChild
              [isHidden]="!field.isVisible" [additionalField]="field.isAdditionalField"
              [fullColumn]="field.isFullColumn"
              [isDisabled]="field.isDisabled"
              [path]="field.path"
              [name]="field.name"
              [externalPropertyViewModel]="getExternalPropertyViewModelFromExternalMetaData(getExternalMetaDataFromFieldMetaData(field))"
              [fieldSeparator]="getExternalMetaDataFromFieldMetaData(field).fieldSeparator"
              [searchProperties]="getExternalMetaDataFromFieldMetaData(field).searchProperties"
              [decodeProperties]="getExternalMetaDataFromFieldMetaData(field).decodeProperties">
            </nts-decode-text-box>
          }
          @if (field.fieldType === fieldType.ExternalList) {
            <nts-external-list #expandableChild
              [isHidden]="!field.isVisible"
              [additionalField]="field.isAdditionalField"
              [fullColumn]="field.isFullColumn"
              [isDisabled]="field.isDisabled"
              [externalPropertyViewModel]="getExternalPropertyViewModelFromExternalMetaData(getExternalMetaDataFromFieldMetaData(field))"
              [fieldSeparator]="getExternalMetaDataFromFieldMetaData(field).fieldSeparator"
              [searchProperties]="getExternalMetaDataFromFieldMetaData(field).searchProperties"
              [decodeProperties]="getExternalMetaDataFromFieldMetaData(field).decodeProperties">
            </nts-external-list>
          }
          @if (field.fieldType === fieldType.Custom) {
            <nts-custom-field-container #expandableChild
              [isHidden]="!field.isVisible" [additionalField]="field.isAdditionalField"
              [isDisabled]="field.isDisabled"
              [fullColumn]="field.isFullColumn" [metaData]="getCustomFieldMetaDataFromFieldMetaData(field)"
              [ovm]="orchestratorViewModel">
            </nts-custom-field-container>
          }
        }
      </nts-expandable>
    }
  </div>
}